(function () {
	'use strict';

	angular
		.module('core.services')
		.service('CompanyService', CompanyService)

	/** @ngInject */
	function CompanyService(HttpService) {
		const CompanyService = {
			getByParameters,
			get,
			getAllResumed,
			getAllClosedResumed,
			getStatus,
			getConsultants,
			getPaymentMethods,
			post,
			put,
			batchUpdate,
			deleteData,
			reopenCompany
		}

		return CompanyService;

		function getByParameters(params) {
			return HttpService.get('/companies/by-parameters', {
				params
			});
		}

		function getPaymentMethods(companyId) {
			return HttpService.get(`/companies/${companyId}/parameters/payment-methods`);
		}

		function get(companyId) {
			return HttpService.get(`/companies/${companyId}`);
		}

		function getAllResumed() {
			return HttpService.get('/companies/resumed-for-listing');
		}

		function getAllClosedResumed() {
			return HttpService.get('/companies/closed/resumed-for-listing');
		}

		function getStatus() {
			return HttpService.get('/companies/status');
		}

		function getConsultants(companyId, onlyActive = null) {
			return HttpService.get(`/companies/${companyId}/consultants`, {
				params: {
					onlyActive
				}
			});
		}

		function post(companyData) {
			return HttpService.post('/companies', companyData);
		}

		function put(companyData) {
			return HttpService.put('/companies', companyData);
		}

		function batchUpdate(updateData) {
			return HttpService.put('/companies/batch-update', updateData);
		}

		function deleteData(companyId) {
			return HttpService.delete(`/companies/${companyId}`);
		}

		function reopenCompany(companyData) {
			return HttpService.post('/companies/recreate', companyData)
		}
	}
}());